"use strict";

var LoggerInstance = require("js-logger").get("CheckoutHelper");

var PaymentHelper = require("./PaymentHelper");
var ShipToAccountHelper = require("./ShipToAccountHelper");

var AccountActions = require("../accountComponents/AccountActions");
var AccountFormHelper = require("../accountComponents/AccountFormHelper");

var CheckoutApi = require("../checkoutComponents/CheckoutApi");
var CheckoutStore = require("../checkoutComponents/CheckoutStore");
var DonationUpsellHelper = require("../checkoutComponents/DonationUpsellHelper");

var Spinner = require("../client/Spinner");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var CheckoutHelper = {
	savedPaymentComponentData: function () {
		var $savedPaymentsComponent = $("div[data-component=savedPayments]");
		var usingSavedPayments = $savedPaymentsComponent.length;

		if (usingSavedPayments) {
			// pull value from radio buttons.
			var $checkedRadioButton = $(`input[name=savedPaymentsComponent]:checked`);

			var type;
			if ($checkedRadioButton.closest("[data-component='savedPayments.creditCard']").length) {
				type = "CC";
			} else if ($checkedRadioButton.closest("[data-component='savedPayments.eft']").length) {
				type = "EFT";
			}

			var savedPaymentRadioValue = $checkedRadioButton.val();

			return {
				newSavedPayment: savedPaymentRadioValue === "NEW",
				savedPaymentCheckout: true,
				savedPaymentId: savedPaymentRadioValue,
				type
			};
		}

		return {
			savedPaymentCheckout: false,
			newSavedPayment: false
		};
	},

	getAccountInfo: function (options) {
		var deferred = new $.Deferred();

		options = options || {};
		var mediaOutlet;

		if (options.isCreateAccount) {
			AccountFormHelper.serializeDataNecessaryToCreateAnAccount().always(accountData => {
				accountData.type = AccountActions.getAccountType(accountData);
				deferred.resolve(accountData);
			});
		} else {
			var account = {};
			AccountFormHelper.updateAccountDemographics(account).always(() => {
				mediaOutlet = AccountFormHelper.getMediaOutlet();
				if (mediaOutlet) {
					account.mediaOutlet = mediaOutlet;
				}

				deferred.resolve(account);
			});
		}
		return deferred;
	},

	getSubscriptionTaxControlRecord: function () {
		var deferred = new $.Deferred();

		if (this.useSubscriptionTax) {
			deferred.resolve(this.useSubscriptionTax);
		} else {
			CheckoutApi.getSubscriptionTaxControlRecord().done((useSubscriptionTax) => {
				this.useSubscriptionTax = useSubscriptionTax.value;
				deferred.resolve(this.useSubscriptionTax);
			}).fail((err) => {
				LoggerInstance.info("Unable to get subscription tax control record.");
				deferred.reject();
			});
		}

		return deferred;
	},

	getShippingTaxId: function () {
		var deferred = new $.Deferred();

		if (this.shipTaxId) {
			deferred.resolve(this.shipTaxId);
		} else {
			CheckoutApi.getShippingTaxId().done((shipTaxId) => {
				this.shipTaxId = shipTaxId.value;
				deferred.resolve(this.shipTaxId);
			}).fail((err) => {
				LoggerInstance.info("Unable to get shipping tax control record.");
				deferred.reject();
			});
		}

		return deferred;
	},

	completeCheckout: function (dataToSend, successCallback, failureCallback, options) {
		dataToSend = dataToSend || {};
		options = options || {};
		var that = this;
		
		// If we are on a Child page, we need to set the sponsorship flag
		if (CheckoutStore.isPageType(Constants.TANGIBLE_TYPES.CHILD)) {
			dataToSend.isSponsorship = true;
		}
		
		CheckoutApi.completeCheckout(dataToSend, options).then((data, textStatus, jqXHR) => {
			if (data.success) {
				// We originally only provided post-submit action processing here because we were using
				// the generic Submit Button component. But this doesn't make sense in this case. All checkout scenarios should
				// forward to the confirmation page.
				if (_.isFunction(successCallback)) {
					successCallback();
				}

				// Used to prevent caching data in session storage on page unload when checkout has completed.
				window.CHECKOUT_COMPLETED = true;

				window.location.href = "/" + CheckoutStore.getConfirmationPageRoute();
			} else {
				if (!that.handleOneTimePasswordError(data.message, dataToSend, successCallback, failureCallback, /*isOTPRequiredByReCAPTCHA*/ false)) {
					var isErrorMessageDisplayed = false;
					if (_.isFunction(failureCallback)) {
						isErrorMessageDisplayed = failureCallback(jqXHR);
					}

					// TODO - Feature #5033 - End User Validation
					// Determine how/where we want to handle API error messagesByField.
					PaymentHelper.clearPaymentData();

					if ((data.responseData || {}).wizardDonationUpsell) {
						CheckoutStore.setDonationUpsellWizard(data.responseData.wizardDonationUpsell);
						DonationUpsellHelper.handleDonationUpsellChange();
					}

					var errorCallback = () => {
						Spinner.removeSpinner();
					};

					if (data.message === CheckoutStore.getRequireDonationChangedMessage() || (data.responseData || {}).shouldReloadPage) {
						errorCallback = () => {
							window.location.reload();
						};
					}

					LoggerInstance.error(data.message, textStatus, jqXHR);
					if (!isErrorMessageDisplayed) {
						BootstrapPrompt.alert(data.message, errorCallback);
					}
				}
			}
		})
		.catch((jqXHR) => {
			// This handles HTTP/network errors (e.g., 400 from reCAPTCHA failure)
			var responseJson = jqXHR && jqXHR.responseJSON && jqXHR.responseJSON;
			var isOTPRequired = responseJson.isOTPRequired;
			var errorMessage = responseJson.message;
			if (!that.handleOneTimePasswordError(errorMessage, dataToSend, successCallback, failureCallback, isOTPRequired)) {
				if (_.isFunction(failureCallback)) {
					failureCallback(jqXHR);
				}
			}
		});
	},

	handleOneTimePasswordError: function (errorMessage, dataToSend, successCallback, failureCallback, isOTPRequiredByReCAPTCHA) {
		//Look if One-Time Password Failed
		var oneTimePasswordMessages = window.CheckoutActions.getOneTimePasswordForGuestCheckoutMessages();
		var isOTPValidationErrorMessage = (oneTimePasswordMessages && oneTimePasswordMessages.invalidOneTimePassword == errorMessage);

		if (isOTPRequiredByReCAPTCHA || isOTPValidationErrorMessage) {
			if (isOTPValidationErrorMessage) {
				BootstrapPrompt.alert(errorMessage);
			}

			//The one-time password was incorrect.  Reshow the message
			var deferred = new $.Deferred();

			window.OneTimePasswordHelper.showOneTimePasswordModal(deferred);
			deferred.done((oneTimePassword) => {
				dataToSend.verificationCode = oneTimePassword;
				this.completeCheckout(dataToSend, successCallback, failureCallback);
			}).fail(() => {
				Spinner.removeSpinner();
			});
			return true;
		}

		return false;
	},

	// Returns the data that we are currently sending to the ASO checkout API resource.
	// The presence of a 'checkoutEvent' indicates that someone is checking out via the regular Submit button.
	getCheckoutData: function (checkoutEvent, shouldApplyPaymentInformation, paymentTermsText) {
		var deferred = new $.Deferred();

		var checkoutDetails = {
			shippingMethod: CheckoutStore.get("shippingMethod")
		};

		// If we are OPCO on a Tangible, we need to get a few more details
		if (!CheckoutStore.isShoppingCart()) {
			var tangibleActions = CheckoutStore.getTangibleActions();
			var tangibleType = CheckoutStore.get("checkoutType");
			if (!tangibleActions) {
				LoggerInstance.error("One page checkout was attempted but checkoutType is missing from the CheckoutStore.");
				Spinner.removeSpinner();
				deferred.resolve();
				return deferred;
			}
			var shoppingCartData = tangibleActions.getShoppingCartData({ tangibleType, paymentTermsText });
			if (shoppingCartData.product) {
				// If we are on OPCO Product page then we need to validate quantity
				var availableQuantity = CheckoutStore.get("availableQuantity");
				if (availableQuantity !== null && shoppingCartData.quantity > availableQuantity) {
					BootstrapPrompt.alert(CheckoutStore.getWizardValue(
						WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
						WizardConstants.CHECKOUT_MESSAGE_FIELDS.AVAILABLE_QUANTITY,
						{ availableQuantity }
					));
					Spinner.removeSpinner();
					deferred.resolve();
					return deferred;
				}
			}
			checkoutDetails.product = shoppingCartData.product;
			checkoutDetails.project = shoppingCartData.project;
			checkoutDetails.pledges = shoppingCartData.pledges;
			checkoutDetails.cartItems = shoppingCartData.cartItems;

			// add coupon to one-page checkout
			// this is sent but not needed for applying a coupon, but it is required
			// for processing an OPCO with an applied coupon.
			checkoutDetails.couponCode = sessionStorage.getItem(`currentCoupon_${CheckoutStore.get("productCode")}`);
		}

		// Get the transaction note if it exists
		var $transactionNote = $("[data-component='transactionNote'] textarea");

		if ($transactionNote.length > 0) {
			checkoutDetails.transactionNote = $transactionNote.val();
		}

		// Get Secure Project/Pledge details if checking out on the Secure Project/Pledge Page
		if (CheckoutStore.isPageType(Constants.TANGIBLE_TYPES.SECURE_PROJECTS)) {
			checkoutDetails.securePageType = Constants.SECURE_PAGE_TYPES.PROJECT;
		} else if (CheckoutStore.isPageType(Constants.TANGIBLE_TYPES.SECURE_PLEDGES)) {
			checkoutDetails.securePageType = Constants.SECURE_PAGE_TYPES.PLEDGE;
		}

		if (checkoutDetails.securePageType) {
			var $secureInput = $("[data-component='textInput'] input[name='secureInput']");
			if ($secureInput.length) {
				checkoutDetails.secureMatchingText = $secureInput.first().val();
			}
		}

		var savedPaymentData = CheckoutHelper.savedPaymentComponentData();

		this.applyPaymentInformationToCheckoutDetails(checkoutEvent, checkoutDetails, savedPaymentData, shouldApplyPaymentInformation).always(checkoutDetailsWithPaymentInformation => {
			if (!checkoutDetailsWithPaymentInformation) {
				Spinner.removeSpinner();
				deferred.resolve();
			} else {
				this.getAccountInfo({
					isCreateAccount: !savedPaymentData.savedPaymentCheckout
				}).always(account => {
					// source and mediaOutlet will be set on the Server with either values from the user's cookie or from defaults. They are not set here.
					var dataToSend = {
						account: account,
						contactMethod: CheckoutStore.get("wizardDefaultContactMethod").defaultContactMethod,
						payment: checkoutDetailsWithPaymentInformation.payment,
						shippingMethod: checkoutDetailsWithPaymentInformation.shippingMethod,
						securePageType: checkoutDetailsWithPaymentInformation.securePageType,
						isPledgeStatementCart: CheckoutStore.get("isInPledgeStatementSession")
					};

					if (checkoutDetailsWithPaymentInformation.transactionNote) {
						dataToSend.transactionNote = checkoutDetailsWithPaymentInformation.transactionNote;
					}

					if (checkoutDetailsWithPaymentInformation.secureMatchingText) {
						dataToSend.secureMatchingText = checkoutDetailsWithPaymentInformation.secureMatchingText;
					}

					var shippingAddressType = ShipToAccountHelper.getShippingAddressType();
					var giftAccount = shippingAddressType === "gift" ? ShipToAccountHelper.getGiftAccountInfo() : null;
					if (giftAccount) {
						dataToSend.recipient = giftAccount;
					}

					var otherShippingAddress = shippingAddressType === "other" ? ShipToAccountHelper.getAlternateShippingAddress() : null;
					if (otherShippingAddress) {
						dataToSend.otherShippingAddress = otherShippingAddress;
					}

					// This will be the case when we are OPCO on a Tangible page
					if (checkoutDetailsWithPaymentInformation.cartItems && checkoutDetailsWithPaymentInformation.project) {
						dataToSend.tangibleCode = checkoutDetailsWithPaymentInformation.project;
						dataToSend.cartItems = checkoutDetailsWithPaymentInformation.cartItems;
						dataToSend.tangibleType = "Project";
						dataToSend.couponCode = checkoutDetailsWithPaymentInformation.couponCode;
					} else if (checkoutDetailsWithPaymentInformation.cartItems && checkoutDetailsWithPaymentInformation.product) {
						dataToSend.tangibleCode = checkoutDetailsWithPaymentInformation.product;
						dataToSend.cartItems = checkoutDetailsWithPaymentInformation.cartItems;
						dataToSend.tangibleType = "Product";
						dataToSend.couponCode = checkoutDetailsWithPaymentInformation.couponCode;
					} else if (checkoutDetailsWithPaymentInformation.pledges && checkoutDetailsWithPaymentInformation.pledges.length) {
						dataToSend.pledges = checkoutDetailsWithPaymentInformation.pledges;
					} else {
						dataToSend.isMultiPageCheckout = true;
					}

					if (DonationUpsellHelper.hasDonationUpsell()) {
						var donationUpsellValues = DonationUpsellHelper.getDonationUpsellCalculationValues();
						dataToSend.lastMinuteDonationCalculation = donationUpsellValues.calculationType;
						dataToSend.lastMinuteDonationAmount = donationUpsellValues.amount;
					};

					// The presence of a 'checkoutEvent' indicates that someone is checking out via the regular Submit button.
					// Securing a payment is only used in the SavedPayment and CACO flows.
					if (checkoutEvent) {
						PaymentHelper.securePayment(dataToSend.payment).done((securedSavedPayment) => {
							if (securedSavedPayment && securedSavedPayment.nonce) {
								dataToSend.payment.hostedPageToken = securedSavedPayment.nonce;
							}

							deferred.resolve(dataToSend);
						}).fail((jqXHR) => {
							if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message) {
								BootstrapPrompt.alert(jqXHR.responseJSON.message);
							}
							Spinner.removeSpinner();
							deferred.resolve();
						});
					} else {
						deferred.resolve(dataToSend);
					}
				});
			}
		});

		return deferred;
	},

	applyInsufficientGiftGroupAmountStyling: function (cartItemId) {
		var groupDonations = CheckoutStore.getGiftGroupDonationsByCartItemId(cartItemId);
		var groupCartItemIds = groupDonations.map(elem => elem.id);
		var minimumDonationErrorClassName = "minimum-amount-group-error";

		// Remove the class from existing items
		$(`.${minimumDonationErrorClassName}`).removeClass(minimumDonationErrorClassName);
		// Find donations that have the given groupId, and put a css class on them
		groupCartItemIds.forEach(groupCartItemId => {
			var $changedAmountDonationElement = $(`div[data-component='cart.populated.project'] div[data-repeated-item-id='${groupCartItemId}']`);
			$changedAmountDonationElement.addClass(minimumDonationErrorClassName);
		});
	},

	applyPaymentInformationToCheckoutDetails: function (checkoutEvent, checkoutDetails, savedPaymentData, shouldApplyPaymentInformation) {
		var deferred = new $.Deferred();

		if (!shouldApplyPaymentInformation) {
			deferred.resolve(checkoutDetails);
			return deferred;
		}

		// See if we require a payment ($0 cart) and if not, don't try and add the payment object.
		var pledgeHasDonationOrRecurring = checkoutDetails.pledges && checkoutDetails.pledges.some(p => p.donateTodaySelected || p.isRecurring);
		var wizardDonationOrRecurringRequired = CheckoutStore.get("wizardDonationRequired") || CheckoutStore.get("wizardRecurringRequired");

		var cartHasTotalOrRecurring = CheckoutStore.getTotalAmount() > 0 ||
			CheckoutStore.hasRecurringDonations() ||
			pledgeHasDonationOrRecurring ||
			wizardDonationOrRecurringRequired;

		if (cartHasTotalOrRecurring) {
			if (savedPaymentData.savedPaymentCheckout && !savedPaymentData.newSavedPayment) {
				// If we are using an existing saved payment for checkout, we short-circuit here
				checkoutDetails.payment = _.merge(
					{},
					{
						saveForLater: false,
						savedPaymentId: savedPaymentData.savedPaymentId,
						type: savedPaymentData.type
					}
				);

				deferred.resolve(checkoutDetails);
			} else {
				var $parentComponent = $(checkoutEvent.target).closest('[data-component="savedPayments"],[data-component="createAccountAndCheckout"]');
				var saveForLater = $parentComponent.find('[data-component="paymentType.savePayment.input"]').prop("checked");
				var useAsPrimary = $parentComponent.find('[data-component="savedPayments.addNew"] [data-component="savedPayments.isPrimary.input"]').prop("checked");

				PaymentHelper.getPaymentData(CheckoutStore.get("wizardCompanyErrorMessages"), CheckoutStore.get("wizardCompanyEftErrorMessages"), (paymentData) => {
					checkoutDetails.payment = _.merge(
						{},
						paymentData,
						{ saveForLater, useAsPrimary }
					);

					deferred.resolve(checkoutDetails);
				}, () => {
					Spinner.removeSpinner();
					deferred.resolve();
				});
			}
		} else {
			//This means we have a $0 cart
			deferred.resolve(checkoutDetails);
		}

		return deferred;
	}
};

module.exports = CheckoutHelper;
